<template>
  <div class="intelligent-assistant" :style="{ height: `${height}px` }">
    <h4>星圈中有一条员工吐槽需要您留意并协助处理，请在本页提交反馈，感谢您的支持！</h4>
    <p class="desc">吐槽内容如下，您也可以直接点击内容进入吐槽详情页面进行匿名留言互动</p>
    <DynamicItem class="make" v-if="loading" @updateItem="updateItem" :upCount="upCount" :isUp="isUp" :downCount="downCount" :isDown="isDown" :isActual="isActual" :tags="tags" :commentCount="commentCount" :id="id" :user="user" :images="images" :crateTime="createTime" :content="content" />
    <div class="content">
      <span>*</span>
      <span>吐槽处理状态</span>
    </div>
    <div class="radius">
      <van-radio-group v-model="state"  direction="horizontal">
        <van-radio :name="0">待处理</van-radio>
        <van-radio :name="1">已处理</van-radio>
        <van-radio :name="2">非管辖范围</van-radio>
      </van-radio-group>
    </div>
    <div class="content">
      <span>*</span>
      <span>反馈备注</span>
    </div>
    <div class="textarea">
      <textarea type="textarea" v-model="remark" placeholder="请备注针对此条吐槽的处理相关信息" />
      <!-- <span>{{remark.length}}/100</span> -->
    </div>
    <div class="footer">
      <button class="submit" @click="submit">提交</button>
    </div>
  </div>
</template>
<script>
import DynamicItem from './Item1'
import { get, post } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { Radio, RadioGroup } from 'vant'
export default {
  components: {
    DynamicItem,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  },
  created () {
    const { id } = this.$route.query
    this.dissId = id
    this.getFeedBackInfo()
    this.getDetails(id)
  },
  data () {
    return {
      loading: false,
      height: window.innerHeight,
      upCount: 0,
      isUp: false,
      isDown: false,
      downCount: 0,
      isActual: false,
      tags: [],
      commentCount: 0,
      id: '',
      dissId: '',
      user: {},
      images: [],
      createTime: '',
      content: '',
      state: 0,
      remark: ''
    }
  },
  methods: {
    submit () {
      const user = getUser('user')
      const promise = post({
        url: `/v1/circle/diss/${this.dissId}/feedback`,
        data: {
          remark: this.remark,
          state: this.state,
          mobile: user.phoneNumber
        }
      })
      promise.then(res => {
        this.$router.replace({
          name: 'MakeComplaints'
        })
      })
    },
    updateItem (reload) {
      Object.assign(this, reload)
    },
    getFeedBackInfo () {
      const user = getUser('user')
      const promise = get({
        url: `/v1/circle/diss/${this.dissId}/feedback/detail?mobile=${user.phoneNumber}`
      })
      promise.then(res => {
        const {
          data: { code, data }
        } = res
        if (Object.is(code, 200)) {
          Object.assign(this, data)
        }
        this.loading = true
      })
    },
    getDetails (id) {
      this.loading = false
      const user = getUser('user')
      const promise = get({
        url: `/diss/detail/${id}/${user.phoneNumber}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
        }
        this.loading = true
      })
    }
  }
}
</script>
<style scoped lang="scss">
::-webkit-input-placeholder {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 22px;
}
.intelligent-assistant {
  padding: 25px 24px 18px;
  width: 100%;
  height: 100%;
  overflow: scroll;
  box-sizing: border-box;
  h4 {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #111F2C;
    line-height: 22px;
  }
  .desc {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A0A5AA;
    line-height: 18px;
    margin-top: 12px;
  }
  .make {
    background: #F5F5F5;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 12px;
  }
  .content {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 18px;
    display: flex;
    margin-top: 24px;
    span {
      &:first-child {
        color: red;
        width: auto;
        margin-right: 8px;
      }
    }
  }
  .radius {
    margin-top: 12px;
    /deep/ .van-radio-group--horizontal {
      display: flex;
      justify-content: space-between;
    }
  }
  .textarea {
    width: 100%;
    height: 160px;
    border-radius: 6px;
    border: 1px solid #E5E5E5;
    margin-top: 8px;
    padding: 16px;
    box-sizing: border-box;
    position: relative;
    // margin-bottom: 60px;
    textarea {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
    }
    span {
      position:absolute;
      right: 6px;
      bottom: 8px;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 24px;
    }
  }
  .footer {
    // position: fixed;
    // width: 100%;
    // height: auto;
    // bottom: 18px;
    // left: 0;
    .submit {
      width: 162px;
      height: 44px;
      background: #3165EC;
      font-size: 17px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 24px;
      border: none;
      outline: none;
      display: block;
      margin: 28px auto 18px;
    }
  }
}
/deep/ .van-radio--horizontal {
  margin-bottom: 12px;
}
</style>
